import { useNavigate } from 'react-router-dom'
import { Footer } from '../components/Footer'
import { CardWithImage } from '../components/CardWithImage'

export default function Research() {
  const navigate = useNavigate()

  const handleNavigation = (href: string) => {
    navigate(href)
  }

  return (
    <div className="min-h-screen bg-[#d6dbdc] dark:bg-black">
      <div className="container mx-auto px-4 py-8 font-mono">
        <h1 className="text-2xl font-bold mb-4 text-black dark:text-white">Research at Seto Labs</h1>
        
        <CardWithImage
          className="mb-8 h-[300px]"
          title="Advancing Technology Frontiers"
          body="Our research division is dedicated to pushing the boundaries of what's possible in technology. We explore emerging technologies and develop innovative solutions that shape the future of software development."
          imageSrc="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-pU3udMydMyvkXRBbNPyEu1dIDwyRuk.png"
        />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Research Focus</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            At Seto Labs, our research initiatives focus on breakthrough technologies that have the potential to transform industries. We combine academic rigor with practical applications to develop solutions that address real-world challenges.
          </p>
        </section>
        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Current Projects</h2>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300">
            <li>Advanced Machine Learning Algorithms</li>
            <li>Quantum Computing Applications</li>
            <li>Distributed Systems Architecture</li>
            <li>Edge Computing Solutions</li>
            <li>Sustainable Technology Development</li>
          </ul>
        </section>
        <section>
          <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">Research Methodology</h2>
          <p className="mb-4 text-gray-700 dark:text-gray-300">
            Our research methodology combines theoretical exploration with practical experimentation. We maintain close collaborations with academic institutions and industry partners, ensuring our research remains at the cutting edge while delivering tangible benefits to our clients and the broader technology community.
          </p>
        </section>
      </div>
      <Footer onNavigate={handleNavigation} />
    </div>
  )
} 